import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetDeclaracionJuradaGarantiasLaboralesByID = {
  status: number | null;
  statusText: string | null;
};

const useGetDeclaracionJuradaGarantiasLaboralesByID = () => {
  const [loadingGetDeclaracionJuradaGarantiasLaboralesByID, setLoadingDeclaracionJuradaGarantiasLaboralesByID] = useState(false);
  const [successGetDeclaracionJuradaGarantiasLaboralesByID, setSuccessDeclaracionJuradaGarantiasLaboralesByID] = useState(false);
  const [errorGetDeclaracionJuradaGarantiasLaboralesByID, setErrorDeclaracionJuradaGarantiasLaboralesByID] = useState<any>(null);
  const [dataGetDeclaracionJuradaGarantiasLaboralesByID, setDataDeclaracionJuradaGarantiasLaborales] = useState<any>(null);

  const [statusGetDeclaracionJuradaGarantiasLaboralesByID, setStatusGetDeclaracionJuradaGarantiasLaboralesByID] =
    useState<StatusGetDeclaracionJuradaGarantiasLaboralesByID>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getDeclaracionJuradaGarantiasLaboralesByID = async (
    userId: string,
    prestacionId: string,
    id: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingDeclaracionJuradaGarantiasLaboralesByID(true);
    setSuccessDeclaracionJuradaGarantiasLaboralesByID(false);
    setErrorDeclaracionJuradaGarantiasLaboralesByID(null);

    try {
      const res = await apiRecord.getSolicitudDeclaracionJuradaGarantiasByID(userId, prestacionId, id);

      setStatusGetDeclaracionJuradaGarantiasLaboralesByID({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessDeclaracionJuradaGarantiasLaboralesByID(true);
      setDataDeclaracionJuradaGarantiasLaborales(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetDeclaracionJuradaGarantiasLaboralesByID({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetDeclaracionJuradaGarantiasLaboralesByID(err);
      console.error("Error en getDeclaracionJuradaGarantiasLaboralesByID:", err);

      throw err;

    } finally {
      setLoadingDeclaracionJuradaGarantiasLaboralesByID(false);
    }
  };

  return {
    getDeclaracionJuradaGarantiasLaboralesByID,
    loadingGetDeclaracionJuradaGarantiasLaboralesByID,
    successGetDeclaracionJuradaGarantiasLaboralesByID,
    errorGetDeclaracionJuradaGarantiasLaboralesByID,
    dataGetDeclaracionJuradaGarantiasLaboralesByID,
    statusGetDeclaracionJuradaGarantiasLaboralesByID
  };
};

export default useGetDeclaracionJuradaGarantiasLaboralesByID;
